import React from 'react';

const TimePicker = ({ selectedTime, onChange }) => {
  const times = [];
  const startTime = new Date(selectedTime).setHours(7, 0, 0, 0);
  const endTime = new Date(selectedTime).setHours(21, 0, 0, 0);
  // Generate times dynamically from 7:00 AM to 9:00 PM with a 30-minute step
  for (let time = startTime; time <= endTime; time += 30 * 60 * 1000) {
    times.push(new Date(time));
  }

  const selectedTimeValue = selectedTime.getTime();
  return (
    <div className="timePicker">
      <select
        className="form-control time-picker-dropdown"
        value={selectedTimeValue}
        onChange={(e) => {
          const selectedValue = e.target.value;
          if (selectedValue) {
            onChange(new Date(parseInt(selectedValue, 10)));
          }
        }}
      >
        <option value="" disabled>Select Time</option>
        {times.map((time) => {
          const timeValue = time.getTime();
          return (
            <option
              key={timeValue}
              value={timeValue}
            >
              {time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default TimePicker;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/TimePicker.js